// Tela exibida durante a recarga automática em uma versão nova: substitui o
// stack trace do error boundary pelo estado de transição, já que a página está
// prestes a recarregar sozinha.

import { useTranslation } from 'react-i18next';

import { Spinner } from '@alamo/ui';

export function BundleUpdatingScreen(): JSX.Element {
  const { t } = useTranslation(['ui']);

  return (
    <div
      className="flex min-h-[50vh] flex-col items-center justify-center gap-4 p-6"
      role="status"
      aria-live="polite"
    >
      <Spinner size="lg" />
      <p className="text-sm font-body text-slate-600">{t('ui:pwa.updating')}</p>
    </div>
  );
}
